/**
 * Conversation creation PostHog contract - product analytics for the campaign-building wizard.
 * Tracks the journey from first intent to saving and sharing a campaign.
 */

export type ConversationCreationStep = 'objectives' | 'builder';

export type ConversationCreationObjectiveType = 'ai_suggestion' | 'manual' | 'scratch';

export type ConversationCreationShareMethod = 
  | 'link' 
  | 'instructions' 
  | 'personalized_link' 
  | 'calendar_google' 
  | 'calendar_outlook' 
  | 'embed_snippet'
  | 'embed_domain_save';

const CONVERSATION_CREATION_EVENT_NAMES_CONST = [
  'conversation_creation.started',
  'conversation_creation.step_reached',
  'conversation_creation.objective_selected',
  'conversation_creation.settings_opened',
  'conversation_creation.saved',
  'conversation_creation.abandoned',
  'conversation_creation.share_clicked',
] as const;

export type ConversationCreationEventName = (typeof CONVERSATION_CREATION_EVENT_NAMES_CONST)[number];

export const CONVERSATION_CREATION_EVENT_NAMES: readonly ConversationCreationEventName[] = CONVERSATION_CREATION_EVENT_NAMES_CONST;

/**
 * Build base properties for conversation creation events.
 */
export function buildConversationCreationProps(
  workspaceId?: string | null,
  extra?: Record<string, unknown>
): Record<string, unknown> {
  return {
    workspace_id: workspaceId || undefined,
    ...extra,
  };
}
